// extracted by mini-css-extract-plugin
export default {"input":"styles_input__aiTbH","error":"styles_error__4tZ22","icon":"styles_icon__J3CVQ"};